import script from "./BattleStage.vue?vue&type=script&setup=true&lang=js"
export * from "./BattleStage.vue?vue&type=script&setup=true&lang=js"

import "./BattleStage.vue?vue&type=style&index=0&id=a04e6606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a04e6606"]])

export default __exports__